import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { confirmFlowsActions } from 'features/confirmFlows';

const useConfirmFlows = () => {
  const dispatch = useDispatch();
  const getConfirmFlow = useCallback(() => dispatch(confirmFlowsActions.getConfirmFlow()), [dispatch]);
  const createConfirmFlow = useCallback(() => dispatch(confirmFlowsActions.createConfirmFlow()), [dispatch]);
  const deleteConfirmFlow = useCallback(() => dispatch(confirmFlowsActions.deleteConfirmFlow()), [dispatch]);
  const clearLocalActiveConfirmFlow = useCallback(() => dispatch(confirmFlowsActions.clearLocalActiveConfirmFlow()), [dispatch]);

  return {
    getConfirmFlow,
    createConfirmFlow,
    deleteConfirmFlow,
    clearLocalActiveConfirmFlow
  };
};

export default useConfirmFlows;